import product from '@/views/product/product'
export default product;